import comp from "./LinkifyModal";
export default comp;
